import React, { Component } from "react";
import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import { Link } from "react-router-dom";
import '../css/IposChilds.css';
import '../css/TotalEMI.css'
import sortsrc from '../../assets/img/sort.png';
import filtersrc from '../../assets/img/filter_icon_black.png';
import TopNavbar from '../js/ChildTopbar';
import MobNavbar from '../js/BottomNav';
import { isMobile } from 'react-device-detect'
import moment from "moment";
// import { Tabs, Tab } from "@tarragon/swipeable-tabs";
import 'ipos/css/TotalEMI.css';
import axios from "axios";
import Backarrow from '../../assets/img/Ipos/backarrow.png';
import mastercardsrc from 'assets/img/mastercard.png';
import 'ipos/css/TotalEMI.css';
import { BeatLoader } from 'react-spinners';
import { css } from '@emotion/core';
import Dnarrow from "../../assets/img/dropdown_arrow.png";
import { Modal } from "react-responsive-modal";
import { Button } from 'react-bootstrap';
import { connect } from "react-redux";
import SweetAlert from 'react-bootstrap-sweetalert';

const override = css`
    position:absolute;
    display: block;
    margin-left:40%;
    margin-top:200px;
    border-color: red;
    text-align: center;
`;


const sortstyle = {
    height: '20px',
    padding: '0px 5px'
}
const FreeEmiReq = {
    merchantId: '',
    utid: '',
    transactionMode: '',
    loginSessionId: '',
    name: '',
    appVersion: '2.1'
};
const settledReq = {
    merchantId: '',
    utid: '',
    transactionMode: '',
    loginSessionId: '',
    name: '',
    appVersion: '2.1'
};

const UnsettledReq = {
    merchantId: '',
    utid: '',
    transactionMode: '',
    loginSessionId: '',
    name: '',
    appVersion: '2.1'
};
const getCardLabelIcons = cardLabel => {
    const icons = [
        {
            key: "AMEX",
            value: require("../../assets/img/cards/amex_icon.png")
        },
        {
            key: "MASTERCARD",
            value: require("../../assets/img/cards/mastercard_icon.png")
        },
        {
            key: "RUPAY",
            value: require("../../assets/img/cards/rupay_icon.png")
        },
        {
            key: "SODEXO",
            value: require("../../assets/img/cards/sodexo_icon.png")
        },
        {
            key: "VISA",
            value: require("../../assets/img/cards/visa_card_icon.png")
        },
        {
            key: "UNKNOWN",
            value: require("../../assets/img/cards/unknownCard.png")
        },
        {
            key: "AMERICAN EXPRESS",
            value: require("../../assets/img/cards/amex_icon.png")
        },
        {
            key: "UPI",
            value: require("../../assets/img/cards/upi.png")
        }
    ];
    let icon = icons.find(icon => icon.key === cardLabel.toUpperCase());
    return icon ? icon.value : require("../../assets/img/cards/unknownCard.png");
    //Sending default VISA card icon only
};

const closeIcon = (
    <svg fill="currentColor" viewBox="0 0 20 20" width={28} height={28}>
        <path
            fillRule="evenodd"
            d=""
            clipRule="evenodd"
        ></path>
    </svg>
)
let userdetail = {
    userName: '',
    sessionId: '',
    merchantId: '',
    activeTerminal: 'All Terminals',
    allTerminals: [],
    currPage: '',
}
let phoneno, decodeddata;
class FreeEmi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            merchantId: '',
            userName: '',
            sessionId: '',
            allTerminals: [],
            currTerminal: "All Terminals",
            currentPage: '',
            appVersion: '',
            loader: false,
            terminalAmt: '',
            zeroCostBrandEmiLimit: {
                terminal: {
                    dateTime: "",
                    calculation: "",
                    currentTime: "",
                    complimentaryLimit: "",
                    limitUsed: "",
                    limitAvailable: "",
                    yesterDayDate: "",
                    nonZeroCostEMITxns: "",
                    accruedLimit: ""
                }
            },
            freeEmi: false,
            todayTxn: {
                dateTime: "",
                amount: "",
                count: "",
                gst: "",
                txnAmount: "",
            },
            tyTrans: false,
            lastSettlement: {
                dateTime: "",
                amount: "",
                utrNo: "",
                utrDate: "",
                isBrandCommission: false,
                processingFees: {
                    cardProcessingFees: "",
                    EMI: "",
                    fee: "",
                    monthlyRental: "",
                },
                count: "",
                gst: "",
                txnAmount: "",


            },
            settled: false,
            unSettledTxn: {
                dateTime: "",
                amount: "",
                isBrandCommission: false,
                processingFees: {
                    cardProcessingFees: "",
                    EMI: "",
                    fee: "",
                    monthlyRental: "",
                },
                count: "",
                gst: "",
                txnAmount: "",
            },
            selectedradio: '',
            unsettled: false,
            ComplimentaryRchrg: '',
            NonZeroCost: '',
            NonZeroDate: '',
            WalletAmt: '',
            WalletAmtAccured: '',
            WalletAmtUsed: '',
            AvailableBalance: '',
            rotation: 0,
            Processingdetails: false,
            FreeEmiAmt: '',
            TodayAmt: '',
            SettledAmt: '',
            UnsettledAmt: '',
            dashboardResponse: false,
            freeEmiResponse: false,
            tyTransResponse: false,
            settledResponse: false,
            unsettledResponse: false,
            freeEmiTransactionCount: '',
            tyTransTransactionCount: '',
            settledTransactionCount: '',
            unsettledTransactionCount: '',
            freeEmiTransactionDetails: [],
            tyTransTransactionDetails: [],
            settledTransactionDetails: [],
            unsettledTransactionDetails: [],
            freeEmiTransactionDetails_initial: [],
            tyTransTransactionDetails_initial: [],
            settledTransactionDetails_initial: [],
            unsettledTransactionDetails_initial: [],
            SortModal: false,
            FilterModal: false,
            sortamountradio: '',
            selectedOption: '',
            modalType: '',
            selectedCheckboxes: {
                eft: false,
                bankemi: false,
                brandemi: false,
                credit: false,
                debit: false,
                sale: false,
                void: false
            },
            alert:false,
            alertMsg:''


        }
        this.rotate = this.rotate.bind(this);
        this.onRadioChangeValue = this.onRadioChangeValue.bind(this);
        this.onCheckboxChangeValue = this.onCheckboxChangeValue.bind(this);
    }
    componentWillMount(){
        this.props.currentMenu("totalemi");
    }
    componentDidMount() {
        // this.fetchLoginData();
        this.setState({ loader: true })
        var jwt = require('jwt-simple');
        var UDtoken = localStorage.getItem("UD");
        const decoded = jwt_decode(localStorage.usertoken);
        phoneno = decoded.phone;
        var secret = jwt.encode(phoneno, 'innoviti');
        decodeddata = jwt.decode(UDtoken, secret);
        this.fetchLoginData();
    }

    fetchLoginData = () => {
        userdetail.merchantId = decodeddata.merchantId;
        userdetail.userName = decodeddata.userName;
        userdetail.sessionId = decodeddata.sessionId;
        userdetail.allTerminals = decodeddata.allTerminals;
        userdetail.activeTerminal = decodeddata.activeTerminal;
        userdetail.appVersion = decodeddata.appVersion;
        userdetail.currPage = decodeddata.currPage.trim();
        this.setState({
            merchantId: userdetail.merchantId,
            userName: userdetail.userName,
            sessionId: userdetail.sessionId,
            allTerminals: userdetail.allTerminals,
            activeTerminal: userdetail.activeTerminal,
            appVersion: userdetail.appVersion,
            currPage: userdetail.currPage,
        })


        if (userdetail.currPage == "freeemi") {
            this.FreeEmiTab();
        }
        else if (userdetail.currPage == "tytrans") {
            this.TyTransTab();
        }
        else if (userdetail.currPage == "settled") {
            this.settledTab();
        }
        else if (userdetail.currPage == "unsettled") {
            this.unsettledTab();
        }

        // let phoneno = "9902922671";

    }
    // this function is used for today's trans as well as free EMI
    fetchTyTransData = () => {
        this.setState({ loader: true })

        FreeEmiReq.merchantId = this.state.merchantId.toString();
        FreeEmiReq.utid = userdetail.activeTerminal.includes("All") ? "ALL" : userdetail.activeTerminal;
        FreeEmiReq.transactionMode = "today";
        FreeEmiReq.loginSessionId = this.state.sessionId;
        FreeEmiReq.name = this.state.name;
        axios
            .post(config.get("API_URL") + "/users/totalemi-allTransactionDetails", FreeEmiReq)
            .then((response) => {
                if (response.data.responseCode == "00") {
                    this.setState({
                        freeEmiTransactionDetails: response.data.responseDetails.transactionDetails,
                        freeEmiTransactionDetails_initial: response.data.responseDetails.transactionDetails,
                        freeEmiTransactionCount: response.data.responseDetails.transactionCount,
                        tyTransTransactionCount: response.data.responseDetails.transactionCount,
                        loader: false,
                        freeEmiResponse: true,
                        tyTransResponse: true,
                    });

                }
                else {
                    alert("Some technical error occured!. Please try again");
                }
            });
    };
    fetchSettledData = () => {
        this.setState({ loader: true })

        settledReq.merchantId = this.state.merchantId.toString();
        settledReq.utid = userdetail.activeTerminal.includes("All") ? "ALL" : userdetail.activeTerminal;
        settledReq.transactionMode = "settled";
        settledReq.loginSessionId = this.state.sessionId;
        settledReq.name = this.state.name;
        axios
            .post(config.get("API_URL") + "/users/totalemi-allTransactionDetails", settledReq)
            .then((response) => {
                if (response.data.responseCode == "00") {
                    this.setState({
                        settledTransactionDetails: response.data.responseDetails.transactionDetails,
                        settledTransactionDetails_initial: response.data.responseDetails.transactionDetails,
                        settledTransactionCount: response.data.responseDetails.transactionCount,
                        loader: false,
                        settledResponse: true,
                    });
                }
                else {
                    alert("Some technical error occured!. Please try again");
                }
            });
    };
    fetchUnsettledData = () => {
        this.setState({ loader: true });

        UnsettledReq.merchantId = this.state.merchantId.toString();
        UnsettledReq.utid = userdetail.activeTerminal.includes("All") ? "ALL" : userdetail.activeTerminal;
        UnsettledReq.transactionMode = "unSettled";
        UnsettledReq.loginSessionId = this.state.sessionId;
        UnsettledReq.name = this.state.name;
        axios
            .post(config.get("API_URL") + "/users/totalemi-allTransactionDetails", UnsettledReq)
            .then((response) => {
                if (response.data.responseCode == "00") {
                    this.setState({
                        unsettledTransactionDetails: response.data.responseDetails.transactionDetails,
                        unsettledTransactionDetails_initial: response.data.responseDetails.transactionDetails,
                        unsettledTransactionCount: response.data.responseDetails.transactionCount,
                        loader: false,
                        unsettledResponse: true,
                    });

                }
                else {
                    alert("Some technical error occured!. Please try again");
                }
            });
    };
    //current terminal request can not be type "ALL"
    fetchFreeEmiDashboardData = () => {
        this.setState({ loader: true });
        axios
            .post(config.get("API_URL") + "/users/totalemi-dashboard", {
                merchantId: this.state.merchantId.toString(),
                utid: userdetail.activeTerminal.includes("All") ? "ALL" : userdetail.activeTerminal,
                loginSessionId: this.state.sessionId,
                name: this.state.userName,
                appVersion: "2.1",
            })
            .then((response) => {

                if (response.data.responseCode == "00") {
                    let FreeEmiTerminal = Object.keys(response.data.responseDetails.zeroCostBrandEmiLimit);
                    this.setState({
                        zeroCostBrandEmiLimit: response.data.responseDetails.zeroCostBrandEmiLimit,
                        todayTxn: response.data.responseDetails.todayTxn,
                        lastSettlement: response.data.responseDetails.lastSettlement,
                        unSettledTxn: response.data.responseDetails.unSettledTxn,
                        dashboardresponse: true,
                        loader: false,
                    });

                    this.setState({
                        ComplimentaryRchrg: this.state.zeroCostBrandEmiLimit[FreeEmiTerminal].complimentaryLimit,
                        NonZeroCost: this.state.zeroCostBrandEmiLimit[FreeEmiTerminal].nonZeroCostEMITxns,
                        NonZeroDate: moment(this.state.zeroCostBrandEmiLimit[FreeEmiTerminal].dateTime).format("DD MMM YYYY"),
                        WalletAmt: this.state.zeroCostBrandEmiLimit[FreeEmiTerminal].accruedLimit,
                        WalletAmtAccured: this.state.zeroCostBrandEmiLimit[FreeEmiTerminal].calculation,
                        WalletAmtUsed: this.state.zeroCostBrandEmiLimit[FreeEmiTerminal].limitUsed,
                        AvailableBalance: this.state.zeroCostBrandEmiLimit[FreeEmiTerminal].limitAvailable,
                    })

                }
                else {
                    alert("Some technical error occured!. Please try again");
                }
            });
    };
    fetchDashboardData = () => {
        this.setState({ loader: true })

        axios
            .post(config.get("API_URL") + "/users/totalemi-dashboard", {
                merchantId: this.state.merchantId.toString(),
                utid: userdetail.activeTerminal.includes("All") ? "ALL" : userdetail.activeTerminal,
                loginSessionId: this.state.sessionId,
                name: this.state.userName,
                appVersion: "2.1",
            })
            .then((response) => {

                if (response.data.responseCode == "00") {
                    let FreeEmiTerminal = Object.keys(response.data.responseDetails.zeroCostBrandEmiLimit);
                    this.setState({
                        zeroCostBrandEmiLimit: response.data.responseDetails.zeroCostBrandEmiLimit,
                        todayTxn: response.data.responseDetails.todayTxn,
                        lastSettlement: response.data.responseDetails.lastSettlement,
                        unSettledTxn: response.data.responseDetails.unSettledTxn,
                        dashboardresponse: true,
                        loader: false,
                    });
                    if (!userdetail.activeTerminal.includes("All")) {
                        this.setState({
                            ComplimentaryRchrg: this.state.zeroCostBrandEmiLimit[FreeEmiTerminal].complimentaryLimit,
                            NonZeroCost: this.state.zeroCostBrandEmiLimit[FreeEmiTerminal].nonZeroCostEMITxns,
                            NonZeroDate: moment(this.state.zeroCostBrandEmiLimit[FreeEmiTerminal].dateTime).format("DD MMM YYYY"),
                            WalletAmt: this.state.zeroCostBrandEmiLimit[FreeEmiTerminal].accruedLimit,
                            WalletAmtAccured: this.state.zeroCostBrandEmiLimit[FreeEmiTerminal].calculation,
                            WalletAmtUsed: this.state.zeroCostBrandEmiLimit[FreeEmiTerminal].limitUsed,
                            AvailableBalance: this.state.zeroCostBrandEmiLimit[FreeEmiTerminal].limitAvailable,
                        })
                    }
                }
                else {
                    alert("Some technical error occured!. Please try again");
                }
            });
    };

    // child tabs functions START
    FreeEmiTab() {
        if (userdetail.allTerminals.length > 1 && userdetail.activeTerminal.includes('All')) {
            this.setState({ TermModal: true });
        }
        else {
            this.setState({
                freeEmi: true,
                tyTrans: false,
                settled: false,
                unsettled: false,
            })
            const interval = setInterval(() => {
                // if (!this.state.dashboardresponse) { 
                this.fetchFreeEmiDashboardData();
                // }
                if (!this.state.freeEmiResponse) { this.fetchTyTransData(); }
                userdetail.currPage = "freeemi";
                clearInterval(interval);
            }, 1000);
        }

    }
    TyTransTab() {
        this.setState({
            freeEmi: false,
            tyTrans: true,
            settled: false,
            unsettled: false,
        })
        const interval = setInterval(() => {
            if (!this.state.dashboardresponse) { this.fetchDashboardData(); }
            if (!this.state.freeEmiResponse) { this.fetchTyTransData(); }
            userdetail.currPage = "tytrans";
            clearInterval(interval);
        }, 1000);

    }
    settledTab() {

        this.setState({
            freeEmi: false,
            tyTrans: false,
            settled: true,
            unsettled: false,
        })
        const interval = setInterval(() => {
            if (!this.state.dashboardresponse) { this.fetchDashboardData(); }
            if (!this.state.settledResponse) { this.fetchSettledData(); }
            userdetail.currPage = "settled";
            clearInterval(interval);
        }, 1000);

    }
    unsettledTab() {

        this.setState({
            freeEmi: false,
            tyTrans: false,
            settled: false,
            unsettled: true,
        })
        const interval = setInterval(() => {
            if (!this.state.dashboardresponse) { this.fetchDashboardData(); }
            if (!this.state.unsettledResponse) { this.fetchUnsettledData(); }
            userdetail.currPage = "unsettled";
            clearInterval(interval);
        }, 1000);

    }

    tyTransSortTransaction = () => {
        this.setState({ SortModal: true, modalType: 'tytranssort' })
    }
    tyTransFilterTransaction = () => {
        this.setState({ FilterModal: true, modalType: 'tytransfilter' })
    }
    settledSortTransaction = () => {
        this.setState({ SortModal: true, modalType: 'settledsort' })
    }
    settledFilterTransaction = () => {
        this.setState({ FilterModal: true, modalType: 'settledfilter' })
    }
    unsettledSortTransaction = () => {
        this.setState({ SortModal: true, modalType: 'unsettledsort' })
    }
    unsettledFilterTransaction = () => {
        this.setState({ FilterModal: true, modalType: 'unsettledfilter' })
    }


    onRadioChangeValue(event) {
        this.setState({ selectedOption: event.target.value })
    }
    onCheckboxChangeValue(event) {
        if (event.target.title === "eft") {
            this.setState(prevState => ({ selectedCheckboxes: { ...prevState.selectedCheckboxes, eft: !this.state.selectedCheckboxes.eft } }))
        }
        else if (event.target.title === "brandemi") {
            this.setState(prevState => ({ selectedCheckboxes: { ...prevState.selectedCheckboxes, brandemi: !this.state.selectedCheckboxes.brandemi } }))
        }
        else if (event.target.title === "bankemi") {
            this.setState(prevState => ({ selectedCheckboxes: { ...prevState.selectedCheckboxes, bankemi: !this.state.selectedCheckboxes.bankemi } }))
        }
        else if (event.target.title === "credit") {
            this.setState(prevState => ({ selectedCheckboxes: { ...prevState.selectedCheckboxes, credit: !this.state.selectedCheckboxes.credit } }))
        }
        else if (event.target.title === "debit") {
            this.setState(prevState => ({ selectedCheckboxes: { ...prevState.selectedCheckboxes, debit: !this.state.selectedCheckboxes.debit } }))
        }
        else if (event.target.title === "sale") {
            this.setState(prevState => ({ selectedCheckboxes: { ...prevState.selectedCheckboxes, sale: !this.state.selectedCheckboxes.sale } }))
        }
        else if (event.target.title === "void") {
            this.setState(prevState => ({ selectedCheckboxes: { ...prevState.selectedCheckboxes, void: !this.state.selectedCheckboxes.void } }))
        }

    }

    applyFilter = () => {
        let checks = this.state.selectedCheckboxes;
        if(!(checks.eft===checks.brandemi===checks.bankemi===checks.credit===checks.debit===checks.sale===checks.void))
        {
           this.setState({alert:true,FilterModal:false,alertMsg:"Please select filter"});
        }
        else{
        var filteredArray = [];
        if (this.state.modalType === "tytransfilter") { filteredArray = this.state.tyTransTransactionDetails_initial; }
        else if (this.state.modalType === "settledfilter") { filteredArray = this.state.settledTransactionDetails_initial; }
        else if (this.state.modalType === "unsettledfilter") { filteredArray = this.state.unsettledTransactionDetails_initial; }


        if (checks.eft) {
            filteredArray = filteredArray.filter(function (data) {
                return data.transactionType.split('-')[0] === "EFT"
            })
        }
        if (checks.brandemi) {
            filteredArray = filteredArray.filter(function (data) {
                return data.transactionType.split('-')[0] === "BRANDEMI"
            })
        }
        if (checks.bankemi) {
            filteredArray = filteredArray.filter(function (data) {
                return data.transactionType.split('-')[0] === "BANKEMI"
            })

        }
        if (checks.credit) {
            filteredArray = filteredArray.filter(function (data) {
                return data.cardType === "CREDIT"
            })

        }
        if (checks.debit) {
            filteredArray = filteredArray.filter(function (data) {
                return data.cardType === "DEBIT"
            })

        }
        if (checks.sale) {
            filteredArray = filteredArray.filter(function (data) {
                return data.transactionType.split('-')[1] === "SALE"
            })

        }
        if (checks.void) {
            filteredArray = filteredArray.filter(function (data) {
                return data.transactionType.split('-')[1] === "VOID"
            })

        }
        this.setState({ unsettledTransactionDetails: filteredArray, FilterModal: false });
    }

    }
    clearFilter = () => {
        if (this.state.modalType === "tytransfilter") {   this.setState({ tyTransTransactionDetails: this.state.tyTransTransactionDetails_initial, FilterModal: false }) }
        else if (this.state.modalType === "settledfilter") {   this.setState({ settledTransactionDetails: this.state.settledTransactionDetails_initial, FilterModal: false })}
        else if (this.state.modalType === "unsettledfilter") {  this.setState({ unsettledTransactionDetails: this.state.unsettledTransactionDetails_initial, FilterModal: false }) }

      
    }
    applySorting = () => {

        if (this.state.modalType === "tytranssort") {
            if (this.state.selectedOption.toString().toLowerCase() === "maxtomin") {
                var maxtomin = this.state.tyTransTransactionDetails.sort(function (a, b) { return b.txnAmount - a.txnAmount });
                this.setState({ tyTransTransactionDetails: maxtomin, SortModal: false })
            }
            else if (this.state.selectedOption.toString().toLowerCase() === "mintomax") {
                var mintomax = this.state.tyTransTransactionDetails.sort(function (a, b) { return a.txnAmount - b.txnAmount });
                this.setState({ tyTransTransactionDetails: mintomax, SortModal: false })
            }
            else if (this.state.selectedOption.toString().toLowerCase() === "newestfirst") {
                var newestfirst = this.state.tyTransTransactionDetails.sort(function (a, b) { return new Date(b.dateTime) - new Date(a.dateTime) });
                this.setState({ tyTransTransactionDetails: newestfirst, SortModal: false })
            }
            else if (this.state.selectedOption.toString().toLowerCase() === "oldestfirst") {
                var oldestfirst = this.state.tyTransTransactionDetails.sort(function (a, b) { return new Date(a.dateTime) - new Date(b.dateTime) });
                this.setState({ tyTransTransactionDetails: oldestfirst, SortModal: false })
            }
            else{
                this.setState({alert:true,SortModal:false, alertMsg:"Please select option"});
            }
        }
        else if (this.state.modalType === "settledsort") {
            if (this.state.selectedOption.toString().toLowerCase() === "maxtomin") {
                var maxtomin = this.state.settledTransactionDetails.sort(function (a, b) { return b.txnAmount - a.txnAmount });
                this.setState({ settledTransactionDetails: maxtomin, SortModal: false })
            }
            else if (this.state.selectedOption.toString().toLowerCase() === "mintomax") {
                var mintomax = this.state.settledTransactionDetails.sort(function (a, b) { return a.txnAmount - b.txnAmount });
                this.setState({ settledTransactionDetails: mintomax, SortModal: false })
            }
            else if (this.state.selectedOption.toString().toLowerCase() === "newestfirst") {
                var newestfirst = this.state.settledTransactionDetails.sort(function (a, b) { return new Date(b.dateTime) - new Date(a.dateTime) });
                this.setState({ settledTransactionDetails: newestfirst, SortModal: false })
            }
            else if (this.state.selectedOption.toString().toLowerCase() === "oldestfirst") {
                var oldestfirst = this.state.settledTransactionDetails.sort(function (a, b) { return new Date(a.dateTime) - new Date(b.dateTime) });
                this.setState({ settledTransactionDetails: oldestfirst, SortModal: false })
            }
            else{
                this.setState({alert:true, SortModal:false,alertMsg:"Please select option"});
            }
        }
        else if (this.state.modalType === "unsettledsort") {
            if (this.state.selectedOption.toString().toLowerCase() === "maxtomin") {
                var maxtomin = this.state.unsettledTransactionDetails.sort(function (a, b) { return b.txnAmount - a.txnAmount });
                this.setState({ unsettledTransactionDetails: maxtomin, SortModal: false })
            }
            else if (this.state.selectedOption.toString().toLowerCase() === "mintomax") {
                var mintomax = this.state.unsettledTransactionDetails.sort(function (a, b) { return a.txnAmount - b.txnAmount });
                this.setState({ unsettledTransactionDetails: mintomax, SortModal: false })
            }
            else if (this.state.selectedOption.toString().toLowerCase() === "newestfirst") {
                var newestfirst = this.state.unsettledTransactionDetails.sort(function (a, b) { return new Date(b.dateTime) - new Date(a.dateTime) });
                this.setState({ unsettledTransactionDetails: newestfirst, SortModal: false })
            }
            else if (this.state.selectedOption.toString().toLowerCase() === "oldestfirst") {
                var oldestfirst = this.state.unsettledTransactionDetails.sort(function (a, b) { return new Date(a.dateTime) - new Date(b.dateTime) });
                this.setState({ unsettledTransactionDetails: oldestfirst, SortModal: false })
            }
            else{
                this.setState({alert:true,SortModal:false, alertMsg:"Please select option"});
            }
        }
    }
    clearSorting = () => {
        var newestfirst;
        if (this.state.modalType === "tytranssort"){ newestfirst = this.state.tyTransTransactionDetails_initial.sort(function (a, b) { return new Date(b.dateTime) - new Date(a.dateTime) });
        this.setState({ tyTransTransactionDetails: newestfirst, SortModal: false })}
        else if (this.state.modalType === "settledsort") {newestfirst = this.state.settledTransactionDetails_initial.sort(function (a, b) { return new Date(b.dateTime) - new Date(a.dateTime) });
        this.setState({ settledTransactionDetails: newestfirst, SortModal: false })}
        else if (this.state.modalType === "unsettledsort"){newestfirst = this.state.unsettledTransactionDetails_initial.sort(function (a, b) { return new Date(b.dateTime) - new Date(a.dateTime) });
        this.setState({ unsettledTransactionDetails: newestfirst, SortModal: false })}
       
    }
    // child tabs functions END
    rotate() {
        this.setState({
            Processingdetails: !this.state.Processingdetails,
        });

        let newRotation = this.state.rotation - 180;
        if (newRotation >= 360) {
            newRotation = -360;
        }
        this.setState({
            rotation: newRotation,
        });
    }
    myCallback = (dataFromChild) => {
        let curr_child_terminal = dataFromChild.trim().includes("All") ? "All Terminals" : dataFromChild.trim();
        if (curr_child_terminal.includes('All') && userdetail.currPage.includes("freeemi")) {
            this.setState({ TermModal: true });
        }
        else {
            this.setState({ currTerminal: curr_child_terminal })
            userdetail.activeTerminal = curr_child_terminal;
            this.fetchDashboardData();
            if (!curr_child_terminal.includes('All'))
                this.fetchFreeEmiDashboardData();
            const interval = setInterval(() => {

                this.fetchTyTransData();
                this.fetchSettledData();
                this.fetchUnsettledData();
                clearInterval(interval);
            }, 500);
        }
    }
    checkterminal = (e) => {
        // console.log(e.target.outerText.trim());
        this.setState({ selectedradio: e.target.title })
    };
    applyterminal = () => {
        let selectedTerminal = this.state.selectedradio;
        userdetail.activeTerminal = selectedTerminal;
        this.setState({ currTerminal: selectedTerminal, TermModal: !this.state.TermModal, })
        // this.FreeEmiTab();
        this.fetchFreeEmiDashboardData();
        this.fetchTyTransData();
        this.setState({
            freeEmi: true,
            tyTrans: false,
            settled: false,
            unsettled: false,
        })
        userdetail.currPage = "freeemi";
    }
    onCloseModal = () => {
        this.setState({
            TermModal: false,
        })
    }
    onCloseSortModal = () => {
        this.setState({
            SortModal: false,
        })
    }
    onCloseFilterModal = () => {
        this.setState({
            FilterModal: false,
        })
    }
    onRadioChangeValue(event) {
        let selectedRadio = event.target.value;
        this.setState({ selectedOption: event.target.value })
    }
    onAlertConfirm = () => {
        this.setState({ alert: false })
            if(this.state.modalType === 'tytranssort')
            this.setState({ SortModal: true, modalType: 'tytranssort' })
            else if(this.state.modalType === 'tytransfilter')
            this.setState({ FilterModal: true, modalType: 'tytransfilter'})
            else if(this.state.modalType === 'settledsort')
            this.setState({ SortModal: true, modalType: 'settledsort'})
            else if(this.state.modalType === 'settledfilter')
            this.setState({ FilterModal: true, modalType: 'settledfilter' })
            else if(this.state.modalType === 'unsettledsort')
            this.setState({ SortModal: true, modalType: 'unsettledsort' })
            else if(this.state.modalType === 'unsettledfilter')
            this.setState({ FilterModal: true, modalType: 'unsettledfilter' })
       
      }
    render() {
        const { rotation } = this.state;
        return (
            <>
                {isMobile && <TopNavbar selectedterminals={userdetail.activeTerminal} allterminals={this.state.allTerminals} callbackFromParent={this.myCallback} />}
                <SweetAlert
                      show={this.state.alert}
                      confirmBtnText="ok"
                      confirmBtnBsStyle="default"
                      title="Alert!"
                      onConfirm={this.onAlertConfirm}
                      btnSize='lg'
                    >
                      {this.state.alertMsg}
                   </SweetAlert>
                <Modal
                    open={this.state.TermModal}
                    onClose={this.onCloseModal}
                    closeOnOverlayClick={false}
                    classNames={{
                        overlay: "customOverlay",
                        modal: "customModal",
                    }}
                    closeIcon={closeIcon}
                    center
                >
                    <h4 style={{ color: '#F47626', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid', paddingBottom: '10px' }} >Select Terminal</h4>
                    <div style={{ padding: '0px 60px' }}>
                        {/* <div onClick={this.checkterminal}>
            <input type="radio"  checked={this.state.selectedradio.includes("All")?true:false}/>
            <h5 style={{ display: 'inline-block', paddingLeft: '10px' }}>All terminals</h5>
            <br />
          </div> */}
                        {this.state.allTerminals.map((val, key) => {
                            return (
                                <div onClick={this.checkterminal}>
                                    <input type="radio" checked={this.state.selectedradio === val} title={val} />
                                    <h5 style={{ display: 'inline-block', paddingLeft: '10px' }} title={val}> {val} (Terminal {key + 1})</h5>
                                    <br />
                                </div>
                            )
                        })
                        }

                    </div>
                    <div className="text-center p-5">
                        <Button
                            style={{
                                background: "#ef7731",
                                color: "#fff",
                                borderRadius: "10px",
                                width: "100px",
                                margin: "5px",
                            }}
                            onClick={this.onCloseModal}
                            align="center"
                        >
                            Cancel
                    </Button>
                        <Button
                            style={{
                                background: "#ef7731",
                                color: "#fff",
                                borderRadius: "10px",
                                width: "100px",
                                margin: "5px",
                            }}
                            onClick={() => { this.applyterminal() }}
                            align="center"
                        >
                            Apply
                    </Button>
                    </div>


                </Modal>
                <Modal
                    open={this.state.SortModal}
                    onClose={this.onCloseSortModal}
                    classNames={{
                        overlay: "customOverlay",
                        modal: "customModal",
                    }}
                    closeIcon={closeIcon}
                    closeOnOverlayClick={false}
                    center
                >
                    <h4 style={{ color: '#F47626', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid', paddingBottom: '10px' }} >Sort Transaction</h4>
                    {/* <img src={sortsrc} style={sortstyle} /> */}
                    <div >
                        <h5 style={{ fontWeight: '600', color: '#666666' }}>Amount</h5>
                        <p style={{ display: 'inline-block', paddingRight: '10px' }}>Min to Max</p>
                        <input type="radio" checked={this.state.selectedOption === "MintoMax"} value="MintoMax" onChange={this.onRadioChangeValue} />

                        <p style={{ display: 'inline-block', padding: '0px 10px' }}>Max to Min</p>
                        <input type="radio" checked={this.state.selectedOption === "MaxtoMin"} value="MaxtoMin" onChange={this.onRadioChangeValue} />
                    </div>
                    <div>
                        <h5 style={{ fontWeight: '600', color: '#666666' }}>Time of Transaction</h5>
                        <p style={{ display: 'inline-block', paddingRight: '10px' }}>Newest First</p>
                        <input type="radio" checked={this.state.selectedOption === "NewestFirst"} value="NewestFirst" onChange={this.onRadioChangeValue} />

                        <p style={{ display: 'inline-block', padding: '0px 10px' }}>Oldest First</p>
                        <input type="radio" checked={this.state.selectedOption === "OldestFirst"} value="OldestFirst" onChange={this.onRadioChangeValue} />



                    </div>
                    <div className="text-center p-5">
                        <Button
                            style={{
                                background: "#ef7731",
                                color: "#fff",
                                borderRadius: "10px",
                                width: "100px",
                                margin: "5px",
                                textTransform: 'none'
                            }}
                            onClick={this.clearSorting}
                            align="center"
                        >
                            Clear All
                    </Button>
                        <Button
                            style={{
                                background: "#ef7731",
                                color: "#fff",
                                borderRadius: "10px",
                                width: "100px",
                                margin: "5px",
                                textTransform: 'none'
                            }}
                            onClick={() => { this.applySorting()}}
                            align="center"
                        >
                            Apply
                    </Button>
                    </div>


                </Modal>
                <Modal
                    open={this.state.FilterModal}
                    onClose={this.onCloseFilterModal}
                    closeOnOverlayClick={false}
                    classNames={{
                        overlay: "customOverlay",
                        modal: "customModal",
                    }}
                    closeIcon={closeIcon}
                    backd
                    center
                >
                    <h4 style={{ color: '#F47626', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid', paddingBottom: '10px' }} >Filter Transaction</h4>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
                        <h5 style={{ fontWeight: '600', color: '#666666' }}>Tender Mode</h5>
                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 p-0">
                            <p style={{ display: 'inline-block', paddingRight: '12px' }}>EFT</p>
                            <input type="checkbox" title="eft" checked={this.state.selectedCheckboxes.eft} onClick={this.onCheckboxChangeValue} />
                        </div>
                        <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 p-0">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8 p-0" style={{ textAlign: 'center' }}>
                                <p style={{ display: 'inline-block', padding: '0px 10px' }}>Bank EMI (Interest Bearing)</p>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 p-0">
                                <input type="checkbox" title="bankemi" checked={this.state.selectedCheckboxes.bankemi} onChange={this.onCheckboxChangeValue} />
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 p-0">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8 p-0" style={{ textAlign: 'center' }}>
                                <p style={{ display: 'inline-block' }}>Brand EMI (Zero Cost)</p>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 p-0">
                                <input type="checkbox" title="brandemi" checked={this.state.selectedCheckboxes.brandemi} onChange={this.onCheckboxChangeValue} />
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
                        <h5 style={{ fontWeight: '600', color: '#666666' }}>Card Type</h5>

                        <p style={{ display: 'inline-block', paddingRight: '6px' }}>Debit</p>
                        <input type="checkbox" title="debit" checked={this.state.selectedCheckboxes.debit} onChange={this.onCheckboxChangeValue} />

                        <div style={{ display: 'inline-block', paddingLeft: '36px' }}>
                            <p style={{ display: 'inline-block', padding: '0px 10px' }}>Credit</p>
                            <input type="checkbox" title="credit" checked={this.state.selectedCheckboxes.credit} onChange={this.onCheckboxChangeValue} />
                        </div>
                    </div>

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0">
                        <h5 style={{ fontWeight: '600', color: '#666666' }}>Txn Type</h5>
                        <p style={{ display: 'inline-block', paddingRight: '10px' }}>Sale</p>
                        <input type="checkbox" title="sale" checked={this.state.selectedCheckboxes.sale} onChange={this.onCheckboxChangeValue} />

                        <div style={{ display: 'inline-block', paddingLeft: '44px' }}>
                            <p style={{ display: 'inline-block', padding: '0px 10px' }}>Void</p>
                            <input type="checkbox" title="void" checked={this.state.selectedCheckboxes.void} onChange={this.onCheckboxChangeValue} />
                        </div>
                    </div>



                    <div className="text-center p-5">
                        <Button
                            style={{
                                background: "#ef7731",
                                color: "#fff",
                                borderRadius: "10px",
                                width: "100px",
                                margin: "5px",
                                textTransform: 'none'
                            }}
                            onClick={this.clearFilter}
                            align="center"
                        >
                            Clear All
                    </Button>
                        <Button
                            style={{
                                background: "#ef7731",
                                color: "#fff",
                                borderRadius: "10px",
                                width: "100px",
                                margin: "5px",
                                textTransform: 'none'
                            }}
                            onClick={this.applyFilter}
                            align="center"
                        >
                            Apply
                    </Button>
                    </div>


                </Modal>
                {/* FreEMI Page START */}
                {this.state.freeEmi &&
                    <div className="fixed-content">
                        <div className="container-fluid">
                            <div className="row">
                                {/* child menu tabs START */}
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ borderBottom: 'darkgray solid 1px' }}>
                                    <div className="content">
                                        <div className="row text-center" style={{ backgroundColor: '#FFFFFF', paddingTop: '10px' }}>


                                            <div className={this.state.freeEmi ? " col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0 org-bottom-border" : "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0"} onClick={() => this.FreeEmiTab()}>
                                                {!isMobile && <Link to="/admin/totalemi-dashboard"> <img height={'25px'} src={Backarrow} style={{ float: 'left' }} /></Link>}
                                                <p className={this.state.freeEmi ? "org-bold-para" : "text-grey"}>Free EMI Wallet</p>
                                            </div>

                                            <div className={this.state.tyTrans ? "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0 org-bottom-border" : "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0"} onClick={() => this.TyTransTab()}>
                                                <p className={this.state.tyTrans ? "org-bold-para" : "text-grey"}>Today's Summary</p>
                                            </div>

                                            <div className={this.state.settled ? "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0 org-bottom-border" : "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0"} onClick={() => this.settledTab()}>
                                                <p className={this.state.settled ? "org-bold-para" : "text-grey"}>Last Settlement</p>
                                            </div>

                                            <div className={this.state.unsettled ? "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0 org-bottom-border" : "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0"} onClick={() => this.unsettledTab()}>
                                                <p className={this.state.unsettled ? "org-bold-para" : "text-grey"}>Unsettled Txns</p>
                                            </div>


                                        </div>
                                    </div>

                                </div>
                                {/* child menu tabs END */}
                                {this.state.loader === false ?
                                    <>
                                        {this.state.freeEmi &&
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div className="content">
                                                    <div className="row">
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12" style={{ marginTop: '15px' }}>
                                                            <div className="card">
                                                                <div className="content text-center">
                                                                    <div className="row" style={{ background: 'linear-gradient(134.72deg, #F5B00A 0%, #FE6009 100%)', marginTop: '-15px' }}>
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center p-5 ">
                                                                            <p style={{ color: '#FFFFFF' }}> {moment(new Date()).format("DD MMM YYYY, hh:mm a")} </p>
                                                                            <h3 style={{ color: '#FFFFFF' }}><strong><span className="inr-sign">{this.state.AvailableBalance.split('.')[0]}.</span><small style={{ color: '#FFFFFF', fontWeight: '600' }}>{this.state.AvailableBalance.split('.')[1]}</small></strong><span className="fs-15"> Available</span></h3>
                                                                            <h5 style={{ color: '#FFFFFF' }}>Free EMI Wallet Balance</h5>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center p-5">

                                                                            <p style={{ fontSize: '16px', fontWeight: '600', color: 'dimgrey' }}>Free EMI Wallet Calculation - {moment(new Date()).format('MMM YYYY')}</p>

                                                                        </div>

                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0" style={{ margin: '0px 10px', borderTop: '1px solid #97979787', width: '95%' }}></div>

                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-5" >
                                                                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 text-left p-0">
                                                                                <p className="fs-12">(A)</p>

                                                                            </div>
                                                                            <div className="col-lg-7 col-md-7 col-sm-7 col-xs-7 text-left p-0">
                                                                                <p>Complimentary Recharge</p>

                                                                            </div>
                                                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 text-right p-0">
                                                                                <p><span className="inr-sign" /> {this.state.ComplimentaryRchrg}</p>

                                                                            </div>


                                                                        </div>

                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-5" >
                                                                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 text-left p-0">

                                                                                <p className="fs-12">(B)</p>

                                                                            </div>
                                                                            <div className="col-lg-7 col-md-7 col-sm-7 col-xs-7 text-left p-0">

                                                                                <p> Non Zero Cost EMI  <br /><span className="fs-12">Txns (Till {this.state.NonZeroDate})</span></p>

                                                                            </div>
                                                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 text-right p-0">

                                                                                <p> <span className="inr-sign" />{this.state.NonZeroCost} </p>

                                                                            </div>


                                                                        </div>

                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-5" >
                                                                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 text-left p-0">

                                                                                <p className="fs-12">(C)</p>

                                                                            </div>
                                                                            <div className="col-lg-7 col-md-7 col-sm-7 col-xs-7 text-left p-0">

                                                                                <p>Wallet Amount  <br /><span className="fs-12">Accrued (A+{this.state.WalletAmtAccured}B)</span></p>

                                                                            </div>
                                                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 text-right p-0">

                                                                                <p><span className="inr-sign" />{this.state.WalletAmt}</p>

                                                                            </div>


                                                                        </div>

                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-5">
                                                                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 text-left p-0">

                                                                                <p className="fs-12">(D)</p>
                                                                            </div>
                                                                            <div className="col-lg-7 col-md-7 col-sm-7 col-xs-7 text-left p-0">

                                                                                <p>Wallet Amount Used</p>
                                                                            </div>
                                                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 text-right p-0">

                                                                                <p><span className="inr-sign" />{this.state.WalletAmtUsed}</p>
                                                                            </div>

                                                                        </div>
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0" style={{ margin: '0px 10px', borderTop: '1px solid #97979787', width: '95%' }}></div>
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-5" >

                                                                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 text-left p-0">
                                                                            </div>
                                                                            <div className="col-lg-7 col-md-7 col-sm-7 col-xs-7 text-left p-0">

                                                                                <p style={{ color: 'red', fontSize: '14px' }}>Available Balance <span className="fs-12">(C-D)</span></p>
                                                                            </div>
                                                                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 text-right p-0">
                                                                                <p style={{ color: 'red', fontSize: '14px' }}><span className="inr-sign" />{this.state.AvailableBalance}</p>
                                                                            </div>


                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {this.state.freeEmiTransactionCount > 0 &&
                                                            <div className="col-lg-6 col-ms-6 col-sm-12 col-xs-12" style={{ marginTop: '15px' }}>
                                                                <div className="card" style={{ minHeight: '490px' }}>
                                                                    <div className="content">
                                                                        <div className="row" style={{ borderBottom: 'darkgray solid 1px' }}>
                                                                            <div className="col-lg-6 col-ms-6 col-sm-6 col-xs-6">
                                                                                <p>Free EMI Wallet <br />( {moment(new Date()).format('MMM-YYYY')} )</p>
                                                                            </div>
                                                                            <div className="col-lg-6 col-ms-6 col-sm-6 col-xs-6">
                                                                                <div className="col-lg-6 col-ms-6 col-sm-6 col-xs-6">
                                                                                    <p>Sort<img src={sortsrc} style={sortstyle} /></p>
                                                                                </div>
                                                                                <div className="col-lg-6 col-ms-6 col-sm-6 col-xs-6">
                                                                                    <p>Filter<img src={filtersrc} style={sortstyle} /></p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="row">
                                                                            {this.state.freeEmiTransactionDetails.map((data, index) => {
                                                                                return (
                                                                                    <>
                                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ padding: '10px 0 0 0' }} >
                                                                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left">
                                                                                                <p style={{ fontSize: '80%' }}> {moment(data.dateTime).format("DD MMM YYYY, hh:mm a")} </p>
                                                                                                {isMobile && (data.txnId.length > 25)
                                                                                                    ?
                                                                                                    <p style={{ fontSize: '100%', color: '#F47626' }}> <u>TXN ID: {data.txnId.substring(0, 25)}...</u> </p>
                                                                                                    :
                                                                                                    <p style={{ fontSize: '100%', color: '#F47626' }}> <u>TXN ID: {data.txnId}</u> </p>
                                                                                                }
                                                                                                <p>
                                                                                                    <img className="mastercard-image" src={mastercardsrc} />{" "}
                                                                                                    <span id="cardno" style={{ fontSize: '13px', color: '#9B9B9B' }}>
                                                                                                        {data.maskCardNumber.substring(data.maskCardNumber.length - 8, data.maskCardNumber.length)} ( {data.cardType} ){' '}
                                                                                                    </span>

                                                                                                    <span id="transtype" style={{ fontSize: '13px', color: '#666666' }}>
                                                                                                        {data.transactionType}
                                                                                                    </span>
                                                                                                </p>



                                                                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-left p-0">
                                                                                                    <p> Txn Amount</p>
                                                                                                </div>
                                                                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right p-0">
                                                                                                    <p> <span className="inr-sign" /> {data.txnAmount}</p>
                                                                                                </div>

                                                                                            </div>

                                                                                        </div>
                                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ margin: '0px 10px', borderTop: '1px solid #97979787', width: '95%' }}></div>
                                                                                    </>
                                                                                );
                                                                            })}
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>

                                                </div>
                                                {/* </div> */}
                                            </div>
                                        }

                                    </>
                                    : null}

                                {this.state.loader &&
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <BeatLoader
                                            css={override}
                                            sizeUnit={"px"}
                                            size={15}
                                            color={'#123abc'}
                                            loading={this.state.loader}
                                        />
                                    </div>
                                }


                            </div>
                        </div>
                    </div>
                }

                {/* FreEMI Page END */}


                {/* TodayTrans Page START */}
                {this.state.tyTrans &&
                    <div className="fixed-content">
                        <div className="container-fluid">
                            <div className="row">
                                {/* child menu tabs START */}
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ borderBottom: 'darkgray solid 1px' }}>
                                    <div className="content">
                                        <div className="row text-center" style={{ backgroundColor: '#FFFFFF', paddingTop: '10px' }}>


                                            <div className={this.state.freeEmi ? " col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0 org-bottom-border" : "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0"} onClick={() => this.FreeEmiTab()}>
                                                {!isMobile && <Link to="/admin/totalemi-dashboard"> <img height={'25px'} src={Backarrow} style={{ float: 'left' }} /></Link>}
                                                <p className={this.state.freeEmi ? "org-bold-para" : "text-grey"}>Free EMI Wallet</p>
                                            </div>

                                            <div className={this.state.tyTrans ? "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0 org-bottom-border" : "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0"} onClick={() => this.TyTransTab()}>
                                                <p className={this.state.tyTrans ? "org-bold-para" : "text-grey"}>Today's Summary</p>
                                            </div>

                                            <div className={this.state.settled ? "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0 org-bottom-border" : "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0"} onClick={() => this.settledTab()}>
                                                <p className={this.state.settled ? "org-bold-para" : "text-grey"}>Last Settlement</p>
                                            </div>

                                            <div className={this.state.unsettled ? "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0 org-bottom-border" : "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0"} onClick={() => this.unsettledTab()}>
                                                <p className={this.state.unsettled ? "org-bold-para" : "text-grey"}>Unsettled Txns</p>
                                            </div>


                                        </div>
                                    </div>

                                </div>
                                {/* child menu tabs END */}
                                {this.state.loader === false ?
                                    <>

                                        {this.state.tyTrans &&
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div className="content">
                                                    <div className="row">
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12" style={{ marginTop: '15px' }}>
                                                            <div className="card">
                                                                <div className="content text-center">
                                                                    <div className="row" style={{ background: 'linear-gradient(134.72deg, #F5B00A 0%, #FE6009 100%)', marginTop: '-15px' }}>
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center p-5">
                                                                            <p style={{ color: '#FFFFFF' }}> {moment(new Date()).format("DD MMM YYYY, hh:mm a")} </p>
                                                                            <h3 style={{ color: '#FFFFFF' }}><strong><span className="inr-sign">  {this.state.todayTxn.amount.split('.')[0]}.</span><small style={{ color: '#FFFFFF', fontWeight: '600' }}>{this.state.todayTxn.amount.split('.')[1]}</small></strong></h3>
                                                                            <h5 style={{ color: '#FFFFFF' }}>Transaction Amount</h5>
                                                                            <h5 style={{ color: '#FFFFFF' }}>( {this.state.todayTxn.count} Transaction )</h5>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        {this.state.tyTransTransactionCount > 0 &&
                                                            <div className="col-lg-6 col-ms-6 col-sm-12 col-xs-12" style={{ marginTop: '15px' }}>
                                                                <div className="card" style={{ minHeight: '285px' }}>
                                                                    <div className="content">
                                                                        <div className="row" style={{ borderBottom: 'darkgray solid 1px' }}>
                                                                            <div className="col-lg-6 col-ms-6 col-sm-6 col-xs-6">
                                                                                <p>All Txns</p>
                                                                            </div>
                                                                            <div className="col-lg-6 col-ms-6 col-sm-6 col-xs-6">
                                                                                <div className="col-lg-6 col-ms-6 col-sm-6 col-xs-6" onClick={this.tyTransSortTransaction}>
                                                                                    <p>Sort<img src={sortsrc} style={sortstyle} /></p>
                                                                                </div>
                                                                                <div className="col-lg-6 col-ms-6 col-sm-6 col-xs-6" onClick={this.tyTransFilterTransaction}>
                                                                                    <p>Filter<img src={filtersrc} style={sortstyle} /></p>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className="row">
                                                                            {this.state.tyTransTransactionDetails.map((data, index) => {
                                                                                return (
                                                                                    <>
                                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ padding: '10px 0 0 0' }} >
                                                                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left">
                                                                                                <p style={{ fontSize: '80%' }}> {moment(data.dateTime).format("DD MMM YYYY, hh:mm a")} </p>
                                                                                                {isMobile && (data.txnId.length > 25)
                                                                                                    ?
                                                                                                    <p style={{ fontSize: '100%', color: '#F47626' }}> <u>TXN ID: {data.txnId.substring(0, 25)}...</u> </p>
                                                                                                    :
                                                                                                    <p style={{ fontSize: '100%', color: '#F47626' }}> <u>TXN ID: {data.txnId}</u> </p>
                                                                                                }
                                                                                                <p>
                                                                                                    <img className="mastercard-image" src={getCardLabelIcons(data.cardLabel)} />{" "}
                                                                                                    <span id="cardno" style={{ fontSize: '13px', color: '#9B9B9B' }}>
                                                                                                        {data.maskCardNumber.substring(data.maskCardNumber.length - 8, data.maskCardNumber.length)} ( {data.cardType} ){' '}
                                                                                                    </span>

                                                                                                    <span id="transtype" style={{ fontSize: '13px', color: '#666666' }}>
                                                                                                        {data.transactionType}
                                                                                                    </span>
                                                                                                </p>



                                                                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-left p-0">
                                                                                                    <p> Txn Amount</p>
                                                                                                </div>
                                                                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right p-0">
                                                                                                    <p> <span className="inr-sign" /> {data.txnAmount}</p>
                                                                                                </div>

                                                                                            </div>

                                                                                        </div>
                                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ margin: '0px 10px', borderTop: '1px solid #97979787', width: '95%' }}></div>
                                                                                    </>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>

                                                </div>

                                            </div>
                                        }

                                    </>
                                    : null}

                                {this.state.loader &&
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <BeatLoader
                                            css={override}
                                            sizeUnit={"px"}
                                            size={15}
                                            color={'#123abc'}
                                            loading={this.state.loader}
                                        />
                                    </div>
                                }


                            </div>
                        </div>
                    </div>
                }
                {/* TodayTrans Page END */}


                {/* Settled Page START */}
                {this.state.settled &&
                    <div className="fixed-content">
                        <div className="container-fluid">
                            <div className="row">
                                {/* child menu tabs START */}
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ borderBottom: 'darkgray solid 1px' }}>
                                    <div className="content">
                                        <div className="row text-center" style={{ backgroundColor: '#FFFFFF', paddingTop: '10px' }}>


                                            <div className={this.state.freeEmi ? " col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0 org-bottom-border" : "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0"} onClick={() => this.FreeEmiTab()}>
                                                {!isMobile && <Link to="/admin/totalemi-dashboard"> <img height={'25px'} src={Backarrow} style={{ float: 'left' }} /></Link>}
                                                <p className={this.state.freeEmi ? "org-bold-para" : "text-grey"}>Free EMI Wallet</p>
                                            </div>

                                            <div className={this.state.tyTrans ? "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0 org-bottom-border" : "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0"} onClick={() => this.TyTransTab()}>
                                                <p className={this.state.tyTrans ? "org-bold-para" : "text-grey"}>Today's Summary</p>
                                            </div>

                                            <div className={this.state.settled ? "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0 org-bottom-border" : "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0"} onClick={() => this.settledTab()}>
                                                <p className={this.state.settled ? "org-bold-para" : "text-grey"}>Last Settlement</p>
                                            </div>

                                            <div className={this.state.unsettled ? "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0 org-bottom-border" : "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0"} onClick={() => this.unsettledTab()}>
                                                <p className={this.state.unsettled ? "org-bold-para" : "text-grey"}>Unsettled Txns</p>
                                            </div>


                                        </div>
                                    </div>

                                </div>
                                {/* child menu tabs END */}
                                {this.state.loader === false ?
                                    <>
                                        {this.state.settled &&
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div className="content">
                                                    <div className="row">
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12" style={{ marginTop: '15px' }}>
                                                            <div className="card">
                                                                <div className="content text-center">
                                                                    <div className="row" style={{ background: 'linear-gradient(134.72deg, #F5B00A 0%, #FE6009 100%)', marginTop: '-15px' }}>
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center p-5 ">
                                                                            <p style={{ color: '#FFFFFF' }}> {moment(new Date()).format("DD MMM YYYY, hh:mm a")} </p>
                                                                            <h3 style={{ color: '#FFFFFF' }}><strong><span className="inr-sign"> {this.state.lastSettlement.amount.split('.')[0]}.</span><small style={{ color: '#FFFFFF', fontWeight: '600' }}>{this.state.lastSettlement.amount.split('.')[1]}</small></strong></h3>
                                                                            <h5 style={{ color: '#FFFFFF' }}>Settlement Amount</h5>
                                                                            <h5 style={{ color: '#FFFFFF' }}>( {this.state.lastSettlement.count} Transaction )</h5>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        {this.state.lastSettlement.utrNo && this.state.lastSettlement.utrNo.includes(',') ?
                                                                            <>
                                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ padding: '10px 0 0 0' }} >
                                                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-left">
                                                                                        <p>UTR No.</p>

                                                                                    </div>
                                                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                                                                                        <p>{this.state.lastSettlement.utrNo.split(",")[0]}</p>

                                                                                    </div>

                                                                                </div>
                                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ margin: '0px 10px', borderTop: '1px solid #97979787', width: '95%' }}></div>
                                                                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ padding: '10px 0 0 0' }} >
                                                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-left">
                                                                                        <p>UTR No.</p>

                                                                                    </div>
                                                                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                                                                                        <p>{this.state.lastSettlement.utrNo.split(",")[1]}</p>

                                                                                    </div>

                                                                                </div>
                                                                            </>
                                                                            :
                                                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ padding: '10px 0 0 0' }} >
                                                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-left">
                                                                                    {this.state.lastSettlement.utrNo && <p>UTR No.</p>}

                                                                                </div>
                                                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                                                                                    <p>{this.state.lastSettlement.utrNo}</p>

                                                                                </div>
                                                                            </div>

                                                                        }
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ margin: '0px 10px', borderTop: '1px solid #97979787', width: '95%' }}></div>
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ padding: '10px 0 0 0' }} >

                                                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-left">

                                                                                <p> Txn Amount</p>

                                                                            </div>
                                                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">

                                                                                <p> <span className="inr-sign" /> {this.state.lastSettlement.txnAmount}</p>

                                                                            </div>


                                                                        </div>
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ margin: '0px 10px', borderTop: '1px solid #97979787', width: '95%' }}></div>
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ padding: '10px 0 0 0' }} >

                                                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-left ">

                                                                                <p>GST</p>

                                                                            </div>
                                                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">

                                                                                <p>- <span className="inr-sign" /> {this.state.lastSettlement.gst}</p>

                                                                            </div>


                                                                        </div>
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ margin: '0px 10px', borderTop: '1px solid #97979787', width: '95%' }}></div>
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ padding: '10px 0 0 0' }}>

                                                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-left">

                                                                                <p style={{ color: '#666666' }}>  <strong>Processing Fees </strong> </p>

                                                                            </div>
                                                                            <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 text-right">

                                                                                <p style={{ color: '#666666' }}> <strong> -<span className="inr-sign" /> {this.state.lastSettlement.processingFees.fee}</strong> </p>

                                                                            </div>
                                                                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 text-left p-0">
                                                                                <img
                                                                                    src={Dnarrow}
                                                                                    onClick={this.rotate}
                                                                                    style={{
                                                                                        transform: `rotate(${rotation}deg)`,
                                                                                        width: "26px",
                                                                                        marginTop: "-5px",
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>

                                                                        {this.state.Processingdetails && <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ padding: '10px 0 0 0', background: '#a9a9a952' }}>
                                                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-left">
                                                                                <p style={{ color: '#666666', fontSize: '13px' }}>  <strong>Card Processing Fees </strong> </p>
                                                                                <p style={{ color: '#666666', fontSize: '13px' }}>  <strong>EMI Processing Fees </strong> </p>
                                                                                {this.state.lastSettlement.processingFees.monthlyRental > 0.00 && <p style={{ color: '#666666', fontSize: '13px' }}>  <strong>Monthly Rental </strong> </p>}
                                                                            </div>
                                                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                                                                                <p style={{ color: '#666666', fontSize: '13px' }}> <strong> -<span className="inr-sign" /> {this.state.lastSettlement.processingFees.cardProcessingFees}</strong> </p>
                                                                                <p style={{ color: '#666666', fontSize: '13px' }}> <strong> -<span className="inr-sign" /> {this.state.lastSettlement.processingFees.EMI}</strong> </p>
                                                                                {this.state.lastSettlement.processingFees.monthlyRental > 0.00 && <p style={{ color: '#666666', fontSize: '13px' }}> <strong> -<span className="inr-sign" /> {this.state.lastSettlement.processingFees.monthlyRental}</strong> </p>}
                                                                            </div>

                                                                        </div>
                                                                        }

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {this.state.settledTransactionCount > 0 &&
                                                            <div className="col-lg-6 col-ms-6 col-sm-12 col-xs-12" style={{ marginTop: '15px' }}>
                                                                <div className="card" style={{ minHeight: '325px' }}>
                                                                    <div className="content">
                                                                        <div className="row" style={{ borderBottom: 'darkgray solid 1px' }}>
                                                                            <div className="col-lg-6 col-ms-6 col-sm-6 col-xs-6">
                                                                                <p>All Txns</p>
                                                                            </div>
                                                                            <div className="col-lg-6 col-ms-6 col-sm-6 col-xs-6">
                                                                                <div className="col-lg-6 col-ms-6 col-sm-6 col-xs-6" onClick={this.settledSortTransaction}>
                                                                                    <p>Sort<img src={sortsrc} style={sortstyle} /></p>
                                                                                </div>
                                                                                <div className="col-lg-6 col-ms-6 col-sm-6 col-xs-6" onClick={this.settledFilterTransaction}>
                                                                                    <p>Filter<img src={filtersrc} style={sortstyle} /></p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="row">
                                                                            {this.state.settledTransactionDetails.map((data, index) => {
                                                                                return (
                                                                                    <>
                                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ padding: '10px 0 0 0' }} >
                                                                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left">
                                                                                                <p style={{ fontSize: '80%' }}> {moment(data.dateTime).format("DD MMM YYYY, hh:mm a")} </p>
                                                                                                {isMobile && (data.txnId.length > 25)
                                                                                                    ?
                                                                                                    <p style={{ fontSize: '100%', color: '#F47626' }}> <u>TXN ID: {data.txnId.substring(0, 25)}...</u> </p>
                                                                                                    :
                                                                                                    <p style={{ fontSize: '100%', color: '#F47626' }}> <u>TXN ID: {data.txnId}</u> </p>
                                                                                                }
                                                                                                <p>
                                                                                                    <img className="mastercard-image" src={getCardLabelIcons(data.cardLabel)} />{" "}
                                                                                                    <span id="cardno" style={{ fontSize: '13px', color: '#9B9B9B' }}>
                                                                                                        {data.maskCardNumber.substring(data.maskCardNumber.length - 8, data.maskCardNumber.length)} ( {data.cardType} ){' '}
                                                                                                    </span>

                                                                                                    <span id="transtype" style={{ fontSize: '13px', color: '#666666' }}>
                                                                                                        {data.transactionType}
                                                                                                    </span>
                                                                                                </p>



                                                                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-left p-0">
                                                                                                    <p> Txn Amount</p>
                                                                                                </div>
                                                                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right p-0">
                                                                                                    <p> <span className="inr-sign" /> {data.txnAmount}</p>
                                                                                                </div>

                                                                                            </div>

                                                                                        </div>
                                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ margin: '0px 10px', borderTop: '1px solid #97979787', width: '95%' }}></div>
                                                                                    </>
                                                                                );
                                                                            })}
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>

                                                </div>

                                            </div>
                                        }

                                    </>
                                    : null}

                                {this.state.loader &&
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <BeatLoader
                                            css={override}
                                            sizeUnit={"px"}
                                            size={15}
                                            color={'#123abc'}
                                            loading={this.state.loader}
                                        />
                                    </div>
                                }


                            </div>
                        </div>
                    </div>
                }
                {/* Settled Page END */}


                {/* Unsettled Page START */}
                {this.state.unsettled &&
                    <div className="fixed-content">
                        <div className="container-fluid">
                            <div className="row">
                                {/* child menu tabs START */}
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ borderBottom: 'darkgray solid 1px' }}>
                                    <div className="content">
                                        <div className="row text-center" style={{ backgroundColor: '#FFFFFF', paddingTop: '10px' }}>


                                            <div className={this.state.freeEmi ? " col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0 org-bottom-border" : "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0"} onClick={() => this.FreeEmiTab()}>
                                                {!isMobile && <Link to="/admin/totalemi-dashboard"> <img height={'25px'} src={Backarrow} style={{ float: 'left' }} /></Link>}
                                                <p className={this.state.freeEmi ? "org-bold-para" : "text-grey"}>Free EMI Wallet</p>
                                            </div>

                                            <div className={this.state.tyTrans ? "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0 org-bottom-border" : "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0"} onClick={() => this.TyTransTab()}>
                                                <p className={this.state.tyTrans ? "org-bold-para" : "text-grey"}>Today's Summary</p>
                                            </div>

                                            <div className={this.state.settled ? "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0 org-bottom-border" : "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0"} onClick={() => this.settledTab()}>
                                                <p className={this.state.settled ? "org-bold-para" : "text-grey"}>Last Settlement</p>
                                            </div>

                                            <div className={this.state.unsettled ? "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0 org-bottom-border" : "col-lg-3 col-md-3 col-sm-3 col-xs-3 p-0"} onClick={() => this.unsettledTab()}>
                                                <p className={this.state.unsettled ? "org-bold-para" : "text-grey"}>Unsettled Txns</p>
                                            </div>


                                        </div>
                                    </div>

                                </div>
                                {/* child menu tabs END */}
                                {this.state.loader === false ?
                                    <>

                                        {this.state.unsettled &&
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <div className="content">
                                                    <div className="row">
                                                        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12" style={{ marginTop: '15px' }}>
                                                            <div className="card">
                                                                <div className="content text-center">
                                                                    <div className="row" style={{ background: 'linear-gradient(134.72deg, #F5B00A 0%, #FE6009 100%)', marginTop: '-15px' }}>
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center p-5 ">
                                                                            <p style={{ color: '#FFFFFF' }}> {moment(new Date()).format("DD MMM YYYY, hh:mm a")} </p>
                                                                            <h3 style={{ color: '#FFFFFF' }}><strong><span className="inr-sign"> {this.state.unSettledTxn.amount.split('.')[0]}.</span><small style={{ color: '#FFFFFF', fontWeight: '600' }}>{this.state.unSettledTxn.amount.split('.')[1]}</small></strong></h3>
                                                                            <h5 style={{ color: '#FFFFFF' }}>Unsettled Amount</h5>
                                                                            <h5 style={{ color: '#FFFFFF' }}>( {this.state.unSettledTxn.count} Transaction )</h5>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">

                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ margin: '0px 10px', borderTop: '1px solid #97979787', width: '95%' }}></div>
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ padding: '10px 0 0 0' }} >

                                                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-left">

                                                                                <p> Txn Amount</p>

                                                                            </div>
                                                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">

                                                                                <p> <span className="inr-sign" /> {this.state.unSettledTxn.txnAmount}</p>

                                                                            </div>


                                                                        </div>
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ margin: '0px 10px', borderTop: '1px solid #97979787', width: '95%' }}></div>
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ padding: '10px 0 0 0' }} >

                                                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-left ">

                                                                                <p>GST</p>

                                                                            </div>
                                                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">

                                                                                <p>- <span className="inr-sign" /> {this.state.unSettledTxn.gst}</p>

                                                                            </div>


                                                                        </div>
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ margin: '0px 10px', borderTop: '1px solid #97979787', width: '95%' }}></div>
                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ padding: '10px 0 0 0' }}>

                                                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-left">

                                                                                <p style={{ color: '#666666' }}>  <strong>Processing Fees </strong> </p>
                                                                            </div>
                                                                            <div className="col-lg-5 col-md-5 col-sm-5 col-xs-5 text-right">

                                                                                <p style={{ color: '#666666' }}> <strong> -<span className="inr-sign" /> {this.state.unSettledTxn.processingFees.fee}</strong> </p>
                                                                            </div>
                                                                            <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1 text-left p-0">
                                                                                <img
                                                                                    src={Dnarrow}
                                                                                    onClick={this.rotate}
                                                                                    style={{
                                                                                        transform: `rotate(${rotation}deg)`,
                                                                                        width: "26px",
                                                                                        marginTop: "-5px",
                                                                                    }}
                                                                                />
                                                                            </div>


                                                                        </div>
                                                                        {this.state.Processingdetails && <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ padding: '10px 0 0 0', background: '#a9a9a952' }}>
                                                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-left">
                                                                                <p style={{ color: '#666666', fontSize: '13px' }}>  <strong>Card Processing Fees </strong> </p>
                                                                                <p style={{ color: '#666666', fontSize: '13px' }}>  <strong>EMI Processing Fees </strong> </p>
                                                                                {this.state.unSettledTxn.processingFees.monthlyRental > 0.00 && <p style={{ color: '#666666', fontSize: '13px' }}>  <strong>Monthly Rental </strong> </p>}
                                                                            </div>
                                                                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right">
                                                                                <p style={{ color: '#666666', fontSize: '13px' }}> <strong> -<span className="inr-sign" /> {this.state.unSettledTxn.processingFees.cardProcessingFees}</strong> </p>
                                                                                <p style={{ color: '#666666', fontSize: '13px' }}> <strong> -<span className="inr-sign" /> {this.state.unSettledTxn.processingFees.EMI}</strong> </p>
                                                                                {this.state.unSettledTxn.processingFees.monthlyRental > 0.00 && <p style={{ color: '#666666', fontSize: '13px' }}> <strong> -<span className="inr-sign" /> {this.state.unSettledTxn.processingFees.monthlyRental}</strong> </p>}
                                                                            </div>

                                                                        </div>
                                                                        }

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {this.state.unsettledTransactionCount > 0 &&
                                                            <div className="col-lg-6 col-ms-6 col-sm-12 col-xs-12" style={{ marginTop: '15px' }}>
                                                                <div className="card" style={{ minHeight: '285px' }}>
                                                                    <div className="content">
                                                                        <div className="row" style={{ borderBottom: 'darkgray solid 1px' }}>
                                                                            <div className="col-lg-6 col-ms-6 col-sm-6 col-xs-6">
                                                                                <p>All Txns</p>
                                                                            </div>
                                                                            <div className="col-lg-6 col-ms-6 col-sm-6 col-xs-6">
                                                                                <div className="col-lg-6 col-ms-6 col-sm-6 col-xs-6" onClick={this.unsettledSortTransaction}>
                                                                                    <p>Sort<img src={sortsrc} style={sortstyle} /></p>
                                                                                </div>
                                                                                <div className="col-lg-6 col-ms-6 col-sm-6 col-xs-6" onClick={this.unsettledFilterTransaction}>
                                                                                    <p>Filter<img src={filtersrc} style={sortstyle} /></p>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div className="row">
                                                                            {this.state.unsettledTransactionDetails.map((data, index) => {
                                                                                return (
                                                                                    <>
                                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ padding: '10px 0 0 0' }} >
                                                                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left">
                                                                                                <p style={{ fontSize: '80%' }}> {moment(data.dateTime).format("DD MMM YYYY, hh:mm a")} </p>
                                                                                                {isMobile && (data.txnId.length > 25)
                                                                                                    ?
                                                                                                    <p style={{ fontSize: '100%', color: '#F47626' }}> <u>TXN ID: {data.txnId.substring(0, 25)}...</u> </p>
                                                                                                    :
                                                                                                    <p style={{ fontSize: '100%', color: '#F47626' }}> <u>TXN ID: {data.txnId}</u> </p>
                                                                                                }
                                                                                                <p>
                                                                                                    <img className="mastercard-image" src={getCardLabelIcons(data.cardLabel)} />{" "}
                                                                                                    <span id="cardno" style={{ fontSize: '13px', color: '#9B9B9B' }}>
                                                                                                        {data.maskCardNumber.substring(data.maskCardNumber.length - 8, data.maskCardNumber.length)} ( {data.cardType} ){' '}
                                                                                                    </span>

                                                                                                    <span id="transtype" style={{ fontSize: '13px', color: '#666666' }}>
                                                                                                        {data.transactionType}
                                                                                                    </span>
                                                                                                </p>



                                                                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-left p-0">
                                                                                                    <p> Txn Amount</p>
                                                                                                </div>
                                                                                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 text-right p-0">
                                                                                                    <p> <span className="inr-sign" /> {data.txnAmount}</p>
                                                                                                </div>

                                                                                            </div>

                                                                                        </div>
                                                                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ margin: '0px 10px', borderTop: '1px solid #97979787', width: '95%' }}></div>
                                                                                    </>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>

                                                </div>
                                            </div>
                                        }
                                    </>
                                    : null}

                                {this.state.loader &&
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <BeatLoader
                                            css={override}
                                            sizeUnit={"px"}
                                            size={15}
                                            color={'#123abc'}
                                            loading={this.state.loader}
                                        />
                                    </div>
                                }


                            </div>
                        </div>
                    </div>
                }
                {/* Unsettled Page END */}

            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        currentMenu: (name) => { dispatch({ type: 'change_menu', payload: name }) }
    }
}
export default connect(null, mapDispatchToProps)(FreeEmi);